/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedTutorialsRouteImport } from './routes/_authenticated/tutorials'
import { Route as AuthenticatedAnnouncementsRouteImport } from './routes/_authenticated/announcements'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedAdminSettingsRouteRouteImport } from './routes/_authenticated/admin-settings/route'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedTicketsIndexRouteImport } from './routes/_authenticated/tickets/index'
import { Route as AuthenticatedTicketCategoriesIndexRouteImport } from './routes/_authenticated/ticket-categories/index'
import { Route as AuthenticatedTermsIndexRouteImport } from './routes/_authenticated/terms/index'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedSizesIndexRouteImport } from './routes/_authenticated/sizes/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedRolesIndexRouteImport } from './routes/_authenticated/roles/index'
import { Route as AuthenticatedRialAdjustmentsIndexRouteImport } from './routes/_authenticated/rial-adjustments/index'
import { Route as AuthenticatedPromoBannersIndexRouteImport } from './routes/_authenticated/promo-banners/index'
import { Route as AuthenticatedProductsIndexRouteImport } from './routes/_authenticated/products/index'
import { Route as AuthenticatedPopularManufacturersIndexRouteImport } from './routes/_authenticated/popular-manufacturers/index'
import { Route as AuthenticatedPlpsIndexRouteImport } from './routes/_authenticated/plps/index'
import { Route as AuthenticatedPersonalBankAccountsIndexRouteImport } from './routes/_authenticated/personal-bank-accounts/index'
import { Route as AuthenticatedPayoutsIndexRouteImport } from './routes/_authenticated/payouts/index'
import { Route as AuthenticatedPayoutsViewIndexRouteImport } from './routes/_authenticated/payouts-view/index'
import { Route as AuthenticatedOrdersIndexRouteImport } from './routes/_authenticated/orders/index'
import { Route as AuthenticatedMoltenGoldSettingsIndexRouteImport } from './routes/_authenticated/molten-gold-settings/index'
import { Route as AuthenticatedLoginBannerIndexRouteImport } from './routes/_authenticated/login-banner/index'
import { Route as AuthenticatedHomepageSectionsIndexRouteImport } from './routes/_authenticated/homepage-sections/index'
import { Route as AuthenticatedHelpCenterIndexRouteImport } from './routes/_authenticated/help-center/index'
import { Route as AuthenticatedGoldPricingIndexRouteImport } from './routes/_authenticated/gold-pricing/index'
import { Route as AuthenticatedDepositsPersonalIndexRouteImport } from './routes/_authenticated/deposits-personal/index'
import { Route as AuthenticatedDepositsPersonalViewIndexRouteImport } from './routes/_authenticated/deposits-personal-view/index'
import { Route as AuthenticatedDepositsCompanyIndexRouteImport } from './routes/_authenticated/deposits-company/index'
import { Route as AuthenticatedDepositsCompanyViewIndexRouteImport } from './routes/_authenticated/deposits-company-view/index'
import { Route as AuthenticatedDepositAllocationsIndexRouteImport } from './routes/_authenticated/deposit-allocations/index'
import { Route as AuthenticatedDeliveryOrdersIndexRouteImport } from './routes/_authenticated/delivery-orders/index'
import { Route as AuthenticatedCompanyBankAccountsIndexRouteImport } from './routes/_authenticated/company-bank-accounts/index'
import { Route as AuthenticatedColorsIndexRouteImport } from './routes/_authenticated/colors/index'
import { Route as AuthenticatedChatsIndexRouteImport } from './routes/_authenticated/chats/index'
import { Route as AuthenticatedCategoriesIndexRouteImport } from './routes/_authenticated/categories/index'
import { Route as AuthenticatedBrandsIndexRouteImport } from './routes/_authenticated/brands/index'
import { Route as AuthenticatedBrandPagesIndexRouteImport } from './routes/_authenticated/brand-pages/index'
import { Route as AuthenticatedAttributesIndexRouteImport } from './routes/_authenticated/attributes/index'
import { Route as AuthenticatedAppsIndexRouteImport } from './routes/_authenticated/apps/index'
import { Route as AuthenticatedAdminSettingsIndexRouteImport } from './routes/_authenticated/admin-settings/index'
import { Route as AuthenticatedActivityTypesIndexRouteImport } from './routes/_authenticated/activity-types/index'
import { Route as AuthenticatedActivityLogIndexRouteImport } from './routes/_authenticated/activity-log/index'
import { Route as AuthenticatedAcquiredUsersIndexRouteImport } from './routes/_authenticated/acquired-users/index'
import { Route as AuthenticatedAcquiredUserBannerIndexRouteImport } from './routes/_authenticated/acquired-user-banner/index'
import { Route as AuthenticatedAccountingOrdersIndexRouteImport } from './routes/_authenticated/accounting-orders/index'
import { Route as AuthenticatedWalletGoldSellRequestsRouteImport } from './routes/_authenticated/wallet/gold-sell-requests'
import { Route as AuthenticatedWalletGoldCreaditTransactionsRouteImport } from './routes/_authenticated/wallet/gold-creadit-transactions'
import { Route as AuthenticatedWalletGoldCashTransactionsRouteImport } from './routes/_authenticated/wallet/gold-cash-transactions'
import { Route as AuthenticatedWalletGoldBuyRequestsRouteImport } from './routes/_authenticated/wallet/gold-buy-requests'
import { Route as AuthenticatedUsersUserIdRouteImport } from './routes/_authenticated/users/$userId'
import { Route as AuthenticatedTicketsTicketIdRouteImport } from './routes/_authenticated/tickets/$ticketId'
import { Route as AuthenticatedStaffUserIdRouteImport } from './routes/_authenticated/staff/$userId'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsDisplayRouteImport } from './routes/_authenticated/settings/display'
import { Route as AuthenticatedSettingsAppearanceRouteImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedReportsStockRouteImport } from './routes/_authenticated/reports/stock'
import { Route as AuthenticatedReportsOtpsRouteImport } from './routes/_authenticated/reports/otps'
import { Route as AuthenticatedReportsLoginsRouteImport } from './routes/_authenticated/reports/logins'
import { Route as AuthenticatedReportsBalanceRouteImport } from './routes/_authenticated/reports/balance'
import { Route as AuthenticatedProductsProductIdRouteImport } from './routes/_authenticated/products/$productId'
import { Route as AuthenticatedOrdersOrderIdRouteImport } from './routes/_authenticated/orders/$orderId'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'
import { Route as AuthenticatedDeliveryOrdersOrderIdRouteImport } from './routes/_authenticated/delivery-orders/$orderId'
import { Route as AuthenticatedAdminSettingsAuditLogsRouteImport } from './routes/_authenticated/admin-settings/audit-logs'
import { Route as AuthenticatedAccountingOrdersOrderIdRouteImport } from './routes/_authenticated/accounting-orders/$orderId'
import { Route as AuthenticatedOrdersPrintOrderIdRouteImport } from './routes/_authenticated/orders/print.$orderId'
import { Route as AuthenticatedOrdersFactorOrderIdRouteImport } from './routes/_authenticated/orders/factor.$orderId'
import { Route as AuthenticatedDeliveryOrdersPrintOrderIdRouteImport } from './routes/_authenticated/delivery-orders/print.$orderId'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTutorialsRoute = AuthenticatedTutorialsRouteImport.update({
  id: '/tutorials',
  path: '/tutorials',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAnnouncementsRoute =
  AuthenticatedAnnouncementsRouteImport.update({
    id: '/announcements',
    path: '/announcements',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminSettingsRouteRoute =
  AuthenticatedAdminSettingsRouteRouteImport.update({
    id: '/admin-settings',
    path: '/admin-settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTicketsIndexRoute =
  AuthenticatedTicketsIndexRouteImport.update({
    id: '/tickets/',
    path: '/tickets/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTicketCategoriesIndexRoute =
  AuthenticatedTicketCategoriesIndexRouteImport.update({
    id: '/ticket-categories/',
    path: '/ticket-categories/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTermsIndexRoute = AuthenticatedTermsIndexRouteImport.update({
  id: '/terms/',
  path: '/terms/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSizesIndexRoute = AuthenticatedSizesIndexRouteImport.update({
  id: '/sizes/',
  path: '/sizes/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedRolesIndexRoute = AuthenticatedRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedRialAdjustmentsIndexRoute =
  AuthenticatedRialAdjustmentsIndexRouteImport.update({
    id: '/rial-adjustments/',
    path: '/rial-adjustments/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPromoBannersIndexRoute =
  AuthenticatedPromoBannersIndexRouteImport.update({
    id: '/promo-banners/',
    path: '/promo-banners/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProductsIndexRoute =
  AuthenticatedProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPopularManufacturersIndexRoute =
  AuthenticatedPopularManufacturersIndexRouteImport.update({
    id: '/popular-manufacturers/',
    path: '/popular-manufacturers/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPlpsIndexRoute = AuthenticatedPlpsIndexRouteImport.update({
  id: '/plps/',
  path: '/plps/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedPersonalBankAccountsIndexRoute =
  AuthenticatedPersonalBankAccountsIndexRouteImport.update({
    id: '/personal-bank-accounts/',
    path: '/personal-bank-accounts/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPayoutsIndexRoute =
  AuthenticatedPayoutsIndexRouteImport.update({
    id: '/payouts/',
    path: '/payouts/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPayoutsViewIndexRoute =
  AuthenticatedPayoutsViewIndexRouteImport.update({
    id: '/payouts-view/',
    path: '/payouts-view/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrdersIndexRoute =
  AuthenticatedOrdersIndexRouteImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMoltenGoldSettingsIndexRoute =
  AuthenticatedMoltenGoldSettingsIndexRouteImport.update({
    id: '/molten-gold-settings/',
    path: '/molten-gold-settings/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLoginBannerIndexRoute =
  AuthenticatedLoginBannerIndexRouteImport.update({
    id: '/login-banner/',
    path: '/login-banner/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHomepageSectionsIndexRoute =
  AuthenticatedHomepageSectionsIndexRouteImport.update({
    id: '/homepage-sections/',
    path: '/homepage-sections/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHelpCenterIndexRoute =
  AuthenticatedHelpCenterIndexRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedGoldPricingIndexRoute =
  AuthenticatedGoldPricingIndexRouteImport.update({
    id: '/gold-pricing/',
    path: '/gold-pricing/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDepositsPersonalIndexRoute =
  AuthenticatedDepositsPersonalIndexRouteImport.update({
    id: '/deposits-personal/',
    path: '/deposits-personal/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDepositsPersonalViewIndexRoute =
  AuthenticatedDepositsPersonalViewIndexRouteImport.update({
    id: '/deposits-personal-view/',
    path: '/deposits-personal-view/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDepositsCompanyIndexRoute =
  AuthenticatedDepositsCompanyIndexRouteImport.update({
    id: '/deposits-company/',
    path: '/deposits-company/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDepositsCompanyViewIndexRoute =
  AuthenticatedDepositsCompanyViewIndexRouteImport.update({
    id: '/deposits-company-view/',
    path: '/deposits-company-view/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDepositAllocationsIndexRoute =
  AuthenticatedDepositAllocationsIndexRouteImport.update({
    id: '/deposit-allocations/',
    path: '/deposit-allocations/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDeliveryOrdersIndexRoute =
  AuthenticatedDeliveryOrdersIndexRouteImport.update({
    id: '/delivery-orders/',
    path: '/delivery-orders/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompanyBankAccountsIndexRoute =
  AuthenticatedCompanyBankAccountsIndexRouteImport.update({
    id: '/company-bank-accounts/',
    path: '/company-bank-accounts/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedColorsIndexRoute =
  AuthenticatedColorsIndexRouteImport.update({
    id: '/colors/',
    path: '/colors/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChatsIndexRoute = AuthenticatedChatsIndexRouteImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCategoriesIndexRoute =
  AuthenticatedCategoriesIndexRouteImport.update({
    id: '/categories/',
    path: '/categories/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBrandsIndexRoute =
  AuthenticatedBrandsIndexRouteImport.update({
    id: '/brands/',
    path: '/brands/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBrandPagesIndexRoute =
  AuthenticatedBrandPagesIndexRouteImport.update({
    id: '/brand-pages/',
    path: '/brand-pages/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAttributesIndexRoute =
  AuthenticatedAttributesIndexRouteImport.update({
    id: '/attributes/',
    path: '/attributes/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAppsIndexRoute = AuthenticatedAppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAdminSettingsIndexRoute =
  AuthenticatedAdminSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAdminSettingsRouteRoute,
  } as any)
const AuthenticatedActivityTypesIndexRoute =
  AuthenticatedActivityTypesIndexRouteImport.update({
    id: '/activity-types/',
    path: '/activity-types/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedActivityLogIndexRoute =
  AuthenticatedActivityLogIndexRouteImport.update({
    id: '/activity-log/',
    path: '/activity-log/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAcquiredUsersIndexRoute =
  AuthenticatedAcquiredUsersIndexRouteImport.update({
    id: '/acquired-users/',
    path: '/acquired-users/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAcquiredUserBannerIndexRoute =
  AuthenticatedAcquiredUserBannerIndexRouteImport.update({
    id: '/acquired-user-banner/',
    path: '/acquired-user-banner/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAccountingOrdersIndexRoute =
  AuthenticatedAccountingOrdersIndexRouteImport.update({
    id: '/accounting-orders/',
    path: '/accounting-orders/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWalletGoldSellRequestsRoute =
  AuthenticatedWalletGoldSellRequestsRouteImport.update({
    id: '/wallet/gold-sell-requests',
    path: '/wallet/gold-sell-requests',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWalletGoldCreaditTransactionsRoute =
  AuthenticatedWalletGoldCreaditTransactionsRouteImport.update({
    id: '/wallet/gold-creadit-transactions',
    path: '/wallet/gold-creadit-transactions',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWalletGoldCashTransactionsRoute =
  AuthenticatedWalletGoldCashTransactionsRouteImport.update({
    id: '/wallet/gold-cash-transactions',
    path: '/wallet/gold-cash-transactions',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWalletGoldBuyRequestsRoute =
  AuthenticatedWalletGoldBuyRequestsRouteImport.update({
    id: '/wallet/gold-buy-requests',
    path: '/wallet/gold-buy-requests',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersUserIdRoute =
  AuthenticatedUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTicketsTicketIdRoute =
  AuthenticatedTicketsTicketIdRouteImport.update({
    id: '/tickets/$ticketId',
    path: '/tickets/$ticketId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStaffUserIdRoute =
  AuthenticatedStaffUserIdRouteImport.update({
    id: '/staff/$userId',
    path: '/staff/$userId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsDisplayRoute =
  AuthenticatedSettingsDisplayRouteImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedReportsStockRoute =
  AuthenticatedReportsStockRouteImport.update({
    id: '/reports/stock',
    path: '/reports/stock',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedReportsOtpsRoute =
  AuthenticatedReportsOtpsRouteImport.update({
    id: '/reports/otps',
    path: '/reports/otps',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedReportsLoginsRoute =
  AuthenticatedReportsLoginsRouteImport.update({
    id: '/reports/logins',
    path: '/reports/logins',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedReportsBalanceRoute =
  AuthenticatedReportsBalanceRouteImport.update({
    id: '/reports/balance',
    path: '/reports/balance',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProductsProductIdRoute =
  AuthenticatedProductsProductIdRouteImport.update({
    id: '/products/$productId',
    path: '/products/$productId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrdersOrderIdRoute =
  AuthenticatedOrdersOrderIdRouteImport.update({
    id: '/orders/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDeliveryOrdersOrderIdRoute =
  AuthenticatedDeliveryOrdersOrderIdRouteImport.update({
    id: '/delivery-orders/$orderId',
    path: '/delivery-orders/$orderId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminSettingsAuditLogsRoute =
  AuthenticatedAdminSettingsAuditLogsRouteImport.update({
    id: '/audit-logs',
    path: '/audit-logs',
    getParentRoute: () => AuthenticatedAdminSettingsRouteRoute,
  } as any)
const AuthenticatedAccountingOrdersOrderIdRoute =
  AuthenticatedAccountingOrdersOrderIdRouteImport.update({
    id: '/accounting-orders/$orderId',
    path: '/accounting-orders/$orderId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrdersPrintOrderIdRoute =
  AuthenticatedOrdersPrintOrderIdRouteImport.update({
    id: '/orders/print/$orderId',
    path: '/orders/print/$orderId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrdersFactorOrderIdRoute =
  AuthenticatedOrdersFactorOrderIdRouteImport.update({
    id: '/orders/factor/$orderId',
    path: '/orders/factor/$orderId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDeliveryOrdersPrintOrderIdRoute =
  AuthenticatedDeliveryOrdersPrintOrderIdRouteImport.update({
    id: '/delivery-orders/print/$orderId',
    path: '/delivery-orders/print/$orderId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/admin-settings': typeof AuthenticatedAdminSettingsRouteRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/sign-in': typeof authSignInRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/announcements': typeof AuthenticatedAnnouncementsRoute
  '/tutorials': typeof AuthenticatedTutorialsRoute
  '/accounting-orders/$orderId': typeof AuthenticatedAccountingOrdersOrderIdRoute
  '/admin-settings/audit-logs': typeof AuthenticatedAdminSettingsAuditLogsRoute
  '/delivery-orders/$orderId': typeof AuthenticatedDeliveryOrdersOrderIdRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/orders/$orderId': typeof AuthenticatedOrdersOrderIdRoute
  '/products/$productId': typeof AuthenticatedProductsProductIdRoute
  '/reports/balance': typeof AuthenticatedReportsBalanceRoute
  '/reports/logins': typeof AuthenticatedReportsLoginsRoute
  '/reports/otps': typeof AuthenticatedReportsOtpsRoute
  '/reports/stock': typeof AuthenticatedReportsStockRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/staff/$userId': typeof AuthenticatedStaffUserIdRoute
  '/tickets/$ticketId': typeof AuthenticatedTicketsTicketIdRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/wallet/gold-buy-requests': typeof AuthenticatedWalletGoldBuyRequestsRoute
  '/wallet/gold-cash-transactions': typeof AuthenticatedWalletGoldCashTransactionsRoute
  '/wallet/gold-creadit-transactions': typeof AuthenticatedWalletGoldCreaditTransactionsRoute
  '/wallet/gold-sell-requests': typeof AuthenticatedWalletGoldSellRequestsRoute
  '/accounting-orders/': typeof AuthenticatedAccountingOrdersIndexRoute
  '/acquired-user-banner/': typeof AuthenticatedAcquiredUserBannerIndexRoute
  '/acquired-users/': typeof AuthenticatedAcquiredUsersIndexRoute
  '/activity-log/': typeof AuthenticatedActivityLogIndexRoute
  '/activity-types/': typeof AuthenticatedActivityTypesIndexRoute
  '/admin-settings/': typeof AuthenticatedAdminSettingsIndexRoute
  '/apps/': typeof AuthenticatedAppsIndexRoute
  '/attributes/': typeof AuthenticatedAttributesIndexRoute
  '/brand-pages/': typeof AuthenticatedBrandPagesIndexRoute
  '/brands/': typeof AuthenticatedBrandsIndexRoute
  '/categories/': typeof AuthenticatedCategoriesIndexRoute
  '/chats/': typeof AuthenticatedChatsIndexRoute
  '/colors/': typeof AuthenticatedColorsIndexRoute
  '/company-bank-accounts/': typeof AuthenticatedCompanyBankAccountsIndexRoute
  '/delivery-orders/': typeof AuthenticatedDeliveryOrdersIndexRoute
  '/deposit-allocations/': typeof AuthenticatedDepositAllocationsIndexRoute
  '/deposits-company-view/': typeof AuthenticatedDepositsCompanyViewIndexRoute
  '/deposits-company/': typeof AuthenticatedDepositsCompanyIndexRoute
  '/deposits-personal-view/': typeof AuthenticatedDepositsPersonalViewIndexRoute
  '/deposits-personal/': typeof AuthenticatedDepositsPersonalIndexRoute
  '/gold-pricing/': typeof AuthenticatedGoldPricingIndexRoute
  '/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/homepage-sections/': typeof AuthenticatedHomepageSectionsIndexRoute
  '/login-banner/': typeof AuthenticatedLoginBannerIndexRoute
  '/molten-gold-settings/': typeof AuthenticatedMoltenGoldSettingsIndexRoute
  '/orders/': typeof AuthenticatedOrdersIndexRoute
  '/payouts-view/': typeof AuthenticatedPayoutsViewIndexRoute
  '/payouts/': typeof AuthenticatedPayoutsIndexRoute
  '/personal-bank-accounts/': typeof AuthenticatedPersonalBankAccountsIndexRoute
  '/plps/': typeof AuthenticatedPlpsIndexRoute
  '/popular-manufacturers/': typeof AuthenticatedPopularManufacturersIndexRoute
  '/products/': typeof AuthenticatedProductsIndexRoute
  '/promo-banners/': typeof AuthenticatedPromoBannersIndexRoute
  '/rial-adjustments/': typeof AuthenticatedRialAdjustmentsIndexRoute
  '/roles/': typeof AuthenticatedRolesIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/sizes/': typeof AuthenticatedSizesIndexRoute
  '/tasks/': typeof AuthenticatedTasksIndexRoute
  '/terms/': typeof AuthenticatedTermsIndexRoute
  '/ticket-categories/': typeof AuthenticatedTicketCategoriesIndexRoute
  '/tickets/': typeof AuthenticatedTicketsIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/delivery-orders/print/$orderId': typeof AuthenticatedDeliveryOrdersPrintOrderIdRoute
  '/orders/factor/$orderId': typeof AuthenticatedOrdersFactorOrderIdRoute
  '/orders/print/$orderId': typeof AuthenticatedOrdersPrintOrderIdRoute
}
export interface FileRoutesByTo {
  '/sign-in': typeof authSignInRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/announcements': typeof AuthenticatedAnnouncementsRoute
  '/tutorials': typeof AuthenticatedTutorialsRoute
  '/': typeof AuthenticatedIndexRoute
  '/accounting-orders/$orderId': typeof AuthenticatedAccountingOrdersOrderIdRoute
  '/admin-settings/audit-logs': typeof AuthenticatedAdminSettingsAuditLogsRoute
  '/delivery-orders/$orderId': typeof AuthenticatedDeliveryOrdersOrderIdRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/orders/$orderId': typeof AuthenticatedOrdersOrderIdRoute
  '/products/$productId': typeof AuthenticatedProductsProductIdRoute
  '/reports/balance': typeof AuthenticatedReportsBalanceRoute
  '/reports/logins': typeof AuthenticatedReportsLoginsRoute
  '/reports/otps': typeof AuthenticatedReportsOtpsRoute
  '/reports/stock': typeof AuthenticatedReportsStockRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/staff/$userId': typeof AuthenticatedStaffUserIdRoute
  '/tickets/$ticketId': typeof AuthenticatedTicketsTicketIdRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/wallet/gold-buy-requests': typeof AuthenticatedWalletGoldBuyRequestsRoute
  '/wallet/gold-cash-transactions': typeof AuthenticatedWalletGoldCashTransactionsRoute
  '/wallet/gold-creadit-transactions': typeof AuthenticatedWalletGoldCreaditTransactionsRoute
  '/wallet/gold-sell-requests': typeof AuthenticatedWalletGoldSellRequestsRoute
  '/accounting-orders': typeof AuthenticatedAccountingOrdersIndexRoute
  '/acquired-user-banner': typeof AuthenticatedAcquiredUserBannerIndexRoute
  '/acquired-users': typeof AuthenticatedAcquiredUsersIndexRoute
  '/activity-log': typeof AuthenticatedActivityLogIndexRoute
  '/activity-types': typeof AuthenticatedActivityTypesIndexRoute
  '/admin-settings': typeof AuthenticatedAdminSettingsIndexRoute
  '/apps': typeof AuthenticatedAppsIndexRoute
  '/attributes': typeof AuthenticatedAttributesIndexRoute
  '/brand-pages': typeof AuthenticatedBrandPagesIndexRoute
  '/brands': typeof AuthenticatedBrandsIndexRoute
  '/categories': typeof AuthenticatedCategoriesIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/colors': typeof AuthenticatedColorsIndexRoute
  '/company-bank-accounts': typeof AuthenticatedCompanyBankAccountsIndexRoute
  '/delivery-orders': typeof AuthenticatedDeliveryOrdersIndexRoute
  '/deposit-allocations': typeof AuthenticatedDepositAllocationsIndexRoute
  '/deposits-company-view': typeof AuthenticatedDepositsCompanyViewIndexRoute
  '/deposits-company': typeof AuthenticatedDepositsCompanyIndexRoute
  '/deposits-personal-view': typeof AuthenticatedDepositsPersonalViewIndexRoute
  '/deposits-personal': typeof AuthenticatedDepositsPersonalIndexRoute
  '/gold-pricing': typeof AuthenticatedGoldPricingIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/homepage-sections': typeof AuthenticatedHomepageSectionsIndexRoute
  '/login-banner': typeof AuthenticatedLoginBannerIndexRoute
  '/molten-gold-settings': typeof AuthenticatedMoltenGoldSettingsIndexRoute
  '/orders': typeof AuthenticatedOrdersIndexRoute
  '/payouts-view': typeof AuthenticatedPayoutsViewIndexRoute
  '/payouts': typeof AuthenticatedPayoutsIndexRoute
  '/personal-bank-accounts': typeof AuthenticatedPersonalBankAccountsIndexRoute
  '/plps': typeof AuthenticatedPlpsIndexRoute
  '/popular-manufacturers': typeof AuthenticatedPopularManufacturersIndexRoute
  '/products': typeof AuthenticatedProductsIndexRoute
  '/promo-banners': typeof AuthenticatedPromoBannersIndexRoute
  '/rial-adjustments': typeof AuthenticatedRialAdjustmentsIndexRoute
  '/roles': typeof AuthenticatedRolesIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/sizes': typeof AuthenticatedSizesIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/terms': typeof AuthenticatedTermsIndexRoute
  '/ticket-categories': typeof AuthenticatedTicketCategoriesIndexRoute
  '/tickets': typeof AuthenticatedTicketsIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/delivery-orders/print/$orderId': typeof AuthenticatedDeliveryOrdersPrintOrderIdRoute
  '/orders/factor/$orderId': typeof AuthenticatedOrdersFactorOrderIdRoute
  '/orders/print/$orderId': typeof AuthenticatedOrdersPrintOrderIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/admin-settings': typeof AuthenticatedAdminSettingsRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/(auth)/sign-in': typeof authSignInRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/announcements': typeof AuthenticatedAnnouncementsRoute
  '/_authenticated/tutorials': typeof AuthenticatedTutorialsRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/accounting-orders/$orderId': typeof AuthenticatedAccountingOrdersOrderIdRoute
  '/_authenticated/admin-settings/audit-logs': typeof AuthenticatedAdminSettingsAuditLogsRoute
  '/_authenticated/delivery-orders/$orderId': typeof AuthenticatedDeliveryOrdersOrderIdRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/orders/$orderId': typeof AuthenticatedOrdersOrderIdRoute
  '/_authenticated/products/$productId': typeof AuthenticatedProductsProductIdRoute
  '/_authenticated/reports/balance': typeof AuthenticatedReportsBalanceRoute
  '/_authenticated/reports/logins': typeof AuthenticatedReportsLoginsRoute
  '/_authenticated/reports/otps': typeof AuthenticatedReportsOtpsRoute
  '/_authenticated/reports/stock': typeof AuthenticatedReportsStockRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/staff/$userId': typeof AuthenticatedStaffUserIdRoute
  '/_authenticated/tickets/$ticketId': typeof AuthenticatedTicketsTicketIdRoute
  '/_authenticated/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/_authenticated/wallet/gold-buy-requests': typeof AuthenticatedWalletGoldBuyRequestsRoute
  '/_authenticated/wallet/gold-cash-transactions': typeof AuthenticatedWalletGoldCashTransactionsRoute
  '/_authenticated/wallet/gold-creadit-transactions': typeof AuthenticatedWalletGoldCreaditTransactionsRoute
  '/_authenticated/wallet/gold-sell-requests': typeof AuthenticatedWalletGoldSellRequestsRoute
  '/_authenticated/accounting-orders/': typeof AuthenticatedAccountingOrdersIndexRoute
  '/_authenticated/acquired-user-banner/': typeof AuthenticatedAcquiredUserBannerIndexRoute
  '/_authenticated/acquired-users/': typeof AuthenticatedAcquiredUsersIndexRoute
  '/_authenticated/activity-log/': typeof AuthenticatedActivityLogIndexRoute
  '/_authenticated/activity-types/': typeof AuthenticatedActivityTypesIndexRoute
  '/_authenticated/admin-settings/': typeof AuthenticatedAdminSettingsIndexRoute
  '/_authenticated/apps/': typeof AuthenticatedAppsIndexRoute
  '/_authenticated/attributes/': typeof AuthenticatedAttributesIndexRoute
  '/_authenticated/brand-pages/': typeof AuthenticatedBrandPagesIndexRoute
  '/_authenticated/brands/': typeof AuthenticatedBrandsIndexRoute
  '/_authenticated/categories/': typeof AuthenticatedCategoriesIndexRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexRoute
  '/_authenticated/colors/': typeof AuthenticatedColorsIndexRoute
  '/_authenticated/company-bank-accounts/': typeof AuthenticatedCompanyBankAccountsIndexRoute
  '/_authenticated/delivery-orders/': typeof AuthenticatedDeliveryOrdersIndexRoute
  '/_authenticated/deposit-allocations/': typeof AuthenticatedDepositAllocationsIndexRoute
  '/_authenticated/deposits-company-view/': typeof AuthenticatedDepositsCompanyViewIndexRoute
  '/_authenticated/deposits-company/': typeof AuthenticatedDepositsCompanyIndexRoute
  '/_authenticated/deposits-personal-view/': typeof AuthenticatedDepositsPersonalViewIndexRoute
  '/_authenticated/deposits-personal/': typeof AuthenticatedDepositsPersonalIndexRoute
  '/_authenticated/gold-pricing/': typeof AuthenticatedGoldPricingIndexRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/_authenticated/homepage-sections/': typeof AuthenticatedHomepageSectionsIndexRoute
  '/_authenticated/login-banner/': typeof AuthenticatedLoginBannerIndexRoute
  '/_authenticated/molten-gold-settings/': typeof AuthenticatedMoltenGoldSettingsIndexRoute
  '/_authenticated/orders/': typeof AuthenticatedOrdersIndexRoute
  '/_authenticated/payouts-view/': typeof AuthenticatedPayoutsViewIndexRoute
  '/_authenticated/payouts/': typeof AuthenticatedPayoutsIndexRoute
  '/_authenticated/personal-bank-accounts/': typeof AuthenticatedPersonalBankAccountsIndexRoute
  '/_authenticated/plps/': typeof AuthenticatedPlpsIndexRoute
  '/_authenticated/popular-manufacturers/': typeof AuthenticatedPopularManufacturersIndexRoute
  '/_authenticated/products/': typeof AuthenticatedProductsIndexRoute
  '/_authenticated/promo-banners/': typeof AuthenticatedPromoBannersIndexRoute
  '/_authenticated/rial-adjustments/': typeof AuthenticatedRialAdjustmentsIndexRoute
  '/_authenticated/roles/': typeof AuthenticatedRolesIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/sizes/': typeof AuthenticatedSizesIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/terms/': typeof AuthenticatedTermsIndexRoute
  '/_authenticated/ticket-categories/': typeof AuthenticatedTicketCategoriesIndexRoute
  '/_authenticated/tickets/': typeof AuthenticatedTicketsIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/delivery-orders/print/$orderId': typeof AuthenticatedDeliveryOrdersPrintOrderIdRoute
  '/_authenticated/orders/factor/$orderId': typeof AuthenticatedOrdersFactorOrderIdRoute
  '/_authenticated/orders/print/$orderId': typeof AuthenticatedOrdersPrintOrderIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin-settings'
    | '/settings'
    | '/sign-in'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/announcements'
    | '/tutorials'
    | '/accounting-orders/$orderId'
    | '/admin-settings/audit-logs'
    | '/delivery-orders/$orderId'
    | '/errors/$error'
    | '/orders/$orderId'
    | '/products/$productId'
    | '/reports/balance'
    | '/reports/logins'
    | '/reports/otps'
    | '/reports/stock'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/staff/$userId'
    | '/tickets/$ticketId'
    | '/users/$userId'
    | '/wallet/gold-buy-requests'
    | '/wallet/gold-cash-transactions'
    | '/wallet/gold-creadit-transactions'
    | '/wallet/gold-sell-requests'
    | '/accounting-orders/'
    | '/acquired-user-banner/'
    | '/acquired-users/'
    | '/activity-log/'
    | '/activity-types/'
    | '/admin-settings/'
    | '/apps/'
    | '/attributes/'
    | '/brand-pages/'
    | '/brands/'
    | '/categories/'
    | '/chats/'
    | '/colors/'
    | '/company-bank-accounts/'
    | '/delivery-orders/'
    | '/deposit-allocations/'
    | '/deposits-company-view/'
    | '/deposits-company/'
    | '/deposits-personal-view/'
    | '/deposits-personal/'
    | '/gold-pricing/'
    | '/help-center/'
    | '/homepage-sections/'
    | '/login-banner/'
    | '/molten-gold-settings/'
    | '/orders/'
    | '/payouts-view/'
    | '/payouts/'
    | '/personal-bank-accounts/'
    | '/plps/'
    | '/popular-manufacturers/'
    | '/products/'
    | '/promo-banners/'
    | '/rial-adjustments/'
    | '/roles/'
    | '/settings/'
    | '/sizes/'
    | '/tasks/'
    | '/terms/'
    | '/ticket-categories/'
    | '/tickets/'
    | '/users/'
    | '/delivery-orders/print/$orderId'
    | '/orders/factor/$orderId'
    | '/orders/print/$orderId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/sign-in'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/announcements'
    | '/tutorials'
    | '/'
    | '/accounting-orders/$orderId'
    | '/admin-settings/audit-logs'
    | '/delivery-orders/$orderId'
    | '/errors/$error'
    | '/orders/$orderId'
    | '/products/$productId'
    | '/reports/balance'
    | '/reports/logins'
    | '/reports/otps'
    | '/reports/stock'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/staff/$userId'
    | '/tickets/$ticketId'
    | '/users/$userId'
    | '/wallet/gold-buy-requests'
    | '/wallet/gold-cash-transactions'
    | '/wallet/gold-creadit-transactions'
    | '/wallet/gold-sell-requests'
    | '/accounting-orders'
    | '/acquired-user-banner'
    | '/acquired-users'
    | '/activity-log'
    | '/activity-types'
    | '/admin-settings'
    | '/apps'
    | '/attributes'
    | '/brand-pages'
    | '/brands'
    | '/categories'
    | '/chats'
    | '/colors'
    | '/company-bank-accounts'
    | '/delivery-orders'
    | '/deposit-allocations'
    | '/deposits-company-view'
    | '/deposits-company'
    | '/deposits-personal-view'
    | '/deposits-personal'
    | '/gold-pricing'
    | '/help-center'
    | '/homepage-sections'
    | '/login-banner'
    | '/molten-gold-settings'
    | '/orders'
    | '/payouts-view'
    | '/payouts'
    | '/personal-bank-accounts'
    | '/plps'
    | '/popular-manufacturers'
    | '/products'
    | '/promo-banners'
    | '/rial-adjustments'
    | '/roles'
    | '/settings'
    | '/sizes'
    | '/tasks'
    | '/terms'
    | '/ticket-categories'
    | '/tickets'
    | '/users'
    | '/delivery-orders/print/$orderId'
    | '/orders/factor/$orderId'
    | '/orders/print/$orderId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/admin-settings'
    | '/_authenticated/settings'
    | '/(auth)/sign-in'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/announcements'
    | '/_authenticated/tutorials'
    | '/_authenticated/'
    | '/_authenticated/accounting-orders/$orderId'
    | '/_authenticated/admin-settings/audit-logs'
    | '/_authenticated/delivery-orders/$orderId'
    | '/_authenticated/errors/$error'
    | '/_authenticated/orders/$orderId'
    | '/_authenticated/products/$productId'
    | '/_authenticated/reports/balance'
    | '/_authenticated/reports/logins'
    | '/_authenticated/reports/otps'
    | '/_authenticated/reports/stock'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/staff/$userId'
    | '/_authenticated/tickets/$ticketId'
    | '/_authenticated/users/$userId'
    | '/_authenticated/wallet/gold-buy-requests'
    | '/_authenticated/wallet/gold-cash-transactions'
    | '/_authenticated/wallet/gold-creadit-transactions'
    | '/_authenticated/wallet/gold-sell-requests'
    | '/_authenticated/accounting-orders/'
    | '/_authenticated/acquired-user-banner/'
    | '/_authenticated/acquired-users/'
    | '/_authenticated/activity-log/'
    | '/_authenticated/activity-types/'
    | '/_authenticated/admin-settings/'
    | '/_authenticated/apps/'
    | '/_authenticated/attributes/'
    | '/_authenticated/brand-pages/'
    | '/_authenticated/brands/'
    | '/_authenticated/categories/'
    | '/_authenticated/chats/'
    | '/_authenticated/colors/'
    | '/_authenticated/company-bank-accounts/'
    | '/_authenticated/delivery-orders/'
    | '/_authenticated/deposit-allocations/'
    | '/_authenticated/deposits-company-view/'
    | '/_authenticated/deposits-company/'
    | '/_authenticated/deposits-personal-view/'
    | '/_authenticated/deposits-personal/'
    | '/_authenticated/gold-pricing/'
    | '/_authenticated/help-center/'
    | '/_authenticated/homepage-sections/'
    | '/_authenticated/login-banner/'
    | '/_authenticated/molten-gold-settings/'
    | '/_authenticated/orders/'
    | '/_authenticated/payouts-view/'
    | '/_authenticated/payouts/'
    | '/_authenticated/personal-bank-accounts/'
    | '/_authenticated/plps/'
    | '/_authenticated/popular-manufacturers/'
    | '/_authenticated/products/'
    | '/_authenticated/promo-banners/'
    | '/_authenticated/rial-adjustments/'
    | '/_authenticated/roles/'
    | '/_authenticated/settings/'
    | '/_authenticated/sizes/'
    | '/_authenticated/tasks/'
    | '/_authenticated/terms/'
    | '/_authenticated/ticket-categories/'
    | '/_authenticated/tickets/'
    | '/_authenticated/users/'
    | '/_authenticated/delivery-orders/print/$orderId'
    | '/_authenticated/orders/factor/$orderId'
    | '/_authenticated/orders/print/$orderId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  authSignInRoute: typeof authSignInRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tutorials': {
      id: '/_authenticated/tutorials'
      path: '/tutorials'
      fullPath: '/tutorials'
      preLoaderRoute: typeof AuthenticatedTutorialsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/announcements': {
      id: '/_authenticated/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof AuthenticatedAnnouncementsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin-settings': {
      id: '/_authenticated/admin-settings'
      path: '/admin-settings'
      fullPath: '/admin-settings'
      preLoaderRoute: typeof AuthenticatedAdminSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tickets/': {
      id: '/_authenticated/tickets/'
      path: '/tickets'
      fullPath: '/tickets/'
      preLoaderRoute: typeof AuthenticatedTicketsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ticket-categories/': {
      id: '/_authenticated/ticket-categories/'
      path: '/ticket-categories'
      fullPath: '/ticket-categories/'
      preLoaderRoute: typeof AuthenticatedTicketCategoriesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/terms/': {
      id: '/_authenticated/terms/'
      path: '/terms'
      fullPath: '/terms/'
      preLoaderRoute: typeof AuthenticatedTermsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sizes/': {
      id: '/_authenticated/sizes/'
      path: '/sizes'
      fullPath: '/sizes/'
      preLoaderRoute: typeof AuthenticatedSizesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/roles/': {
      id: '/_authenticated/roles/'
      path: '/roles'
      fullPath: '/roles/'
      preLoaderRoute: typeof AuthenticatedRolesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/rial-adjustments/': {
      id: '/_authenticated/rial-adjustments/'
      path: '/rial-adjustments'
      fullPath: '/rial-adjustments/'
      preLoaderRoute: typeof AuthenticatedRialAdjustmentsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/promo-banners/': {
      id: '/_authenticated/promo-banners/'
      path: '/promo-banners'
      fullPath: '/promo-banners/'
      preLoaderRoute: typeof AuthenticatedPromoBannersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/products/': {
      id: '/_authenticated/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AuthenticatedProductsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/popular-manufacturers/': {
      id: '/_authenticated/popular-manufacturers/'
      path: '/popular-manufacturers'
      fullPath: '/popular-manufacturers/'
      preLoaderRoute: typeof AuthenticatedPopularManufacturersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/plps/': {
      id: '/_authenticated/plps/'
      path: '/plps'
      fullPath: '/plps/'
      preLoaderRoute: typeof AuthenticatedPlpsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/personal-bank-accounts/': {
      id: '/_authenticated/personal-bank-accounts/'
      path: '/personal-bank-accounts'
      fullPath: '/personal-bank-accounts/'
      preLoaderRoute: typeof AuthenticatedPersonalBankAccountsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/payouts/': {
      id: '/_authenticated/payouts/'
      path: '/payouts'
      fullPath: '/payouts/'
      preLoaderRoute: typeof AuthenticatedPayoutsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/payouts-view/': {
      id: '/_authenticated/payouts-view/'
      path: '/payouts-view'
      fullPath: '/payouts-view/'
      preLoaderRoute: typeof AuthenticatedPayoutsViewIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/orders/': {
      id: '/_authenticated/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AuthenticatedOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/molten-gold-settings/': {
      id: '/_authenticated/molten-gold-settings/'
      path: '/molten-gold-settings'
      fullPath: '/molten-gold-settings/'
      preLoaderRoute: typeof AuthenticatedMoltenGoldSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/login-banner/': {
      id: '/_authenticated/login-banner/'
      path: '/login-banner'
      fullPath: '/login-banner/'
      preLoaderRoute: typeof AuthenticatedLoginBannerIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/homepage-sections/': {
      id: '/_authenticated/homepage-sections/'
      path: '/homepage-sections'
      fullPath: '/homepage-sections/'
      preLoaderRoute: typeof AuthenticatedHomepageSectionsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center/'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/gold-pricing/': {
      id: '/_authenticated/gold-pricing/'
      path: '/gold-pricing'
      fullPath: '/gold-pricing/'
      preLoaderRoute: typeof AuthenticatedGoldPricingIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/deposits-personal/': {
      id: '/_authenticated/deposits-personal/'
      path: '/deposits-personal'
      fullPath: '/deposits-personal/'
      preLoaderRoute: typeof AuthenticatedDepositsPersonalIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/deposits-personal-view/': {
      id: '/_authenticated/deposits-personal-view/'
      path: '/deposits-personal-view'
      fullPath: '/deposits-personal-view/'
      preLoaderRoute: typeof AuthenticatedDepositsPersonalViewIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/deposits-company/': {
      id: '/_authenticated/deposits-company/'
      path: '/deposits-company'
      fullPath: '/deposits-company/'
      preLoaderRoute: typeof AuthenticatedDepositsCompanyIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/deposits-company-view/': {
      id: '/_authenticated/deposits-company-view/'
      path: '/deposits-company-view'
      fullPath: '/deposits-company-view/'
      preLoaderRoute: typeof AuthenticatedDepositsCompanyViewIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/deposit-allocations/': {
      id: '/_authenticated/deposit-allocations/'
      path: '/deposit-allocations'
      fullPath: '/deposit-allocations/'
      preLoaderRoute: typeof AuthenticatedDepositAllocationsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/delivery-orders/': {
      id: '/_authenticated/delivery-orders/'
      path: '/delivery-orders'
      fullPath: '/delivery-orders/'
      preLoaderRoute: typeof AuthenticatedDeliveryOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/company-bank-accounts/': {
      id: '/_authenticated/company-bank-accounts/'
      path: '/company-bank-accounts'
      fullPath: '/company-bank-accounts/'
      preLoaderRoute: typeof AuthenticatedCompanyBankAccountsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/colors/': {
      id: '/_authenticated/colors/'
      path: '/colors'
      fullPath: '/colors/'
      preLoaderRoute: typeof AuthenticatedColorsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats/'
      preLoaderRoute: typeof AuthenticatedChatsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/': {
      id: '/_authenticated/categories/'
      path: '/categories'
      fullPath: '/categories/'
      preLoaderRoute: typeof AuthenticatedCategoriesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/brands/': {
      id: '/_authenticated/brands/'
      path: '/brands'
      fullPath: '/brands/'
      preLoaderRoute: typeof AuthenticatedBrandsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/brand-pages/': {
      id: '/_authenticated/brand-pages/'
      path: '/brand-pages'
      fullPath: '/brand-pages/'
      preLoaderRoute: typeof AuthenticatedBrandPagesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/attributes/': {
      id: '/_authenticated/attributes/'
      path: '/attributes'
      fullPath: '/attributes/'
      preLoaderRoute: typeof AuthenticatedAttributesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/': {
      id: '/_authenticated/apps/'
      path: '/apps'
      fullPath: '/apps/'
      preLoaderRoute: typeof AuthenticatedAppsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin-settings/': {
      id: '/_authenticated/admin-settings/'
      path: '/'
      fullPath: '/admin-settings/'
      preLoaderRoute: typeof AuthenticatedAdminSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminSettingsRouteRoute
    }
    '/_authenticated/activity-types/': {
      id: '/_authenticated/activity-types/'
      path: '/activity-types'
      fullPath: '/activity-types/'
      preLoaderRoute: typeof AuthenticatedActivityTypesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/activity-log/': {
      id: '/_authenticated/activity-log/'
      path: '/activity-log'
      fullPath: '/activity-log/'
      preLoaderRoute: typeof AuthenticatedActivityLogIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/acquired-users/': {
      id: '/_authenticated/acquired-users/'
      path: '/acquired-users'
      fullPath: '/acquired-users/'
      preLoaderRoute: typeof AuthenticatedAcquiredUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/acquired-user-banner/': {
      id: '/_authenticated/acquired-user-banner/'
      path: '/acquired-user-banner'
      fullPath: '/acquired-user-banner/'
      preLoaderRoute: typeof AuthenticatedAcquiredUserBannerIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/accounting-orders/': {
      id: '/_authenticated/accounting-orders/'
      path: '/accounting-orders'
      fullPath: '/accounting-orders/'
      preLoaderRoute: typeof AuthenticatedAccountingOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/wallet/gold-sell-requests': {
      id: '/_authenticated/wallet/gold-sell-requests'
      path: '/wallet/gold-sell-requests'
      fullPath: '/wallet/gold-sell-requests'
      preLoaderRoute: typeof AuthenticatedWalletGoldSellRequestsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/wallet/gold-creadit-transactions': {
      id: '/_authenticated/wallet/gold-creadit-transactions'
      path: '/wallet/gold-creadit-transactions'
      fullPath: '/wallet/gold-creadit-transactions'
      preLoaderRoute: typeof AuthenticatedWalletGoldCreaditTransactionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/wallet/gold-cash-transactions': {
      id: '/_authenticated/wallet/gold-cash-transactions'
      path: '/wallet/gold-cash-transactions'
      fullPath: '/wallet/gold-cash-transactions'
      preLoaderRoute: typeof AuthenticatedWalletGoldCashTransactionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/wallet/gold-buy-requests': {
      id: '/_authenticated/wallet/gold-buy-requests'
      path: '/wallet/gold-buy-requests'
      fullPath: '/wallet/gold-buy-requests'
      preLoaderRoute: typeof AuthenticatedWalletGoldBuyRequestsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/$userId': {
      id: '/_authenticated/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthenticatedUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tickets/$ticketId': {
      id: '/_authenticated/tickets/$ticketId'
      path: '/tickets/$ticketId'
      fullPath: '/tickets/$ticketId'
      preLoaderRoute: typeof AuthenticatedTicketsTicketIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/staff/$userId': {
      id: '/_authenticated/staff/$userId'
      path: '/staff/$userId'
      fullPath: '/staff/$userId'
      preLoaderRoute: typeof AuthenticatedStaffUserIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/reports/stock': {
      id: '/_authenticated/reports/stock'
      path: '/reports/stock'
      fullPath: '/reports/stock'
      preLoaderRoute: typeof AuthenticatedReportsStockRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/reports/otps': {
      id: '/_authenticated/reports/otps'
      path: '/reports/otps'
      fullPath: '/reports/otps'
      preLoaderRoute: typeof AuthenticatedReportsOtpsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/reports/logins': {
      id: '/_authenticated/reports/logins'
      path: '/reports/logins'
      fullPath: '/reports/logins'
      preLoaderRoute: typeof AuthenticatedReportsLoginsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/reports/balance': {
      id: '/_authenticated/reports/balance'
      path: '/reports/balance'
      fullPath: '/reports/balance'
      preLoaderRoute: typeof AuthenticatedReportsBalanceRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/products/$productId': {
      id: '/_authenticated/products/$productId'
      path: '/products/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof AuthenticatedProductsProductIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/orders/$orderId': {
      id: '/_authenticated/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AuthenticatedOrdersOrderIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/delivery-orders/$orderId': {
      id: '/_authenticated/delivery-orders/$orderId'
      path: '/delivery-orders/$orderId'
      fullPath: '/delivery-orders/$orderId'
      preLoaderRoute: typeof AuthenticatedDeliveryOrdersOrderIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin-settings/audit-logs': {
      id: '/_authenticated/admin-settings/audit-logs'
      path: '/audit-logs'
      fullPath: '/admin-settings/audit-logs'
      preLoaderRoute: typeof AuthenticatedAdminSettingsAuditLogsRouteImport
      parentRoute: typeof AuthenticatedAdminSettingsRouteRoute
    }
    '/_authenticated/accounting-orders/$orderId': {
      id: '/_authenticated/accounting-orders/$orderId'
      path: '/accounting-orders/$orderId'
      fullPath: '/accounting-orders/$orderId'
      preLoaderRoute: typeof AuthenticatedAccountingOrdersOrderIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/orders/print/$orderId': {
      id: '/_authenticated/orders/print/$orderId'
      path: '/orders/print/$orderId'
      fullPath: '/orders/print/$orderId'
      preLoaderRoute: typeof AuthenticatedOrdersPrintOrderIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/orders/factor/$orderId': {
      id: '/_authenticated/orders/factor/$orderId'
      path: '/orders/factor/$orderId'
      fullPath: '/orders/factor/$orderId'
      preLoaderRoute: typeof AuthenticatedOrdersFactorOrderIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/delivery-orders/print/$orderId': {
      id: '/_authenticated/delivery-orders/print/$orderId'
      path: '/delivery-orders/print/$orderId'
      fullPath: '/delivery-orders/print/$orderId'
      preLoaderRoute: typeof AuthenticatedDeliveryOrdersPrintOrderIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedAdminSettingsRouteRouteChildren {
  AuthenticatedAdminSettingsAuditLogsRoute: typeof AuthenticatedAdminSettingsAuditLogsRoute
  AuthenticatedAdminSettingsIndexRoute: typeof AuthenticatedAdminSettingsIndexRoute
}

const AuthenticatedAdminSettingsRouteRouteChildren: AuthenticatedAdminSettingsRouteRouteChildren =
  {
    AuthenticatedAdminSettingsAuditLogsRoute:
      AuthenticatedAdminSettingsAuditLogsRoute,
    AuthenticatedAdminSettingsIndexRoute: AuthenticatedAdminSettingsIndexRoute,
  }

const AuthenticatedAdminSettingsRouteRouteWithChildren =
  AuthenticatedAdminSettingsRouteRoute._addFileChildren(
    AuthenticatedAdminSettingsRouteRouteChildren,
  )

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsDisplayRoute: typeof AuthenticatedSettingsDisplayRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
    AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
    AuthenticatedSettingsDisplayRoute: AuthenticatedSettingsDisplayRoute,
    AuthenticatedSettingsNotificationsRoute:
      AuthenticatedSettingsNotificationsRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminSettingsRouteRoute: typeof AuthenticatedAdminSettingsRouteRouteWithChildren
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedAnnouncementsRoute: typeof AuthenticatedAnnouncementsRoute
  AuthenticatedTutorialsRoute: typeof AuthenticatedTutorialsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAccountingOrdersOrderIdRoute: typeof AuthenticatedAccountingOrdersOrderIdRoute
  AuthenticatedDeliveryOrdersOrderIdRoute: typeof AuthenticatedDeliveryOrdersOrderIdRoute
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
  AuthenticatedOrdersOrderIdRoute: typeof AuthenticatedOrdersOrderIdRoute
  AuthenticatedProductsProductIdRoute: typeof AuthenticatedProductsProductIdRoute
  AuthenticatedReportsBalanceRoute: typeof AuthenticatedReportsBalanceRoute
  AuthenticatedReportsLoginsRoute: typeof AuthenticatedReportsLoginsRoute
  AuthenticatedReportsOtpsRoute: typeof AuthenticatedReportsOtpsRoute
  AuthenticatedReportsStockRoute: typeof AuthenticatedReportsStockRoute
  AuthenticatedStaffUserIdRoute: typeof AuthenticatedStaffUserIdRoute
  AuthenticatedTicketsTicketIdRoute: typeof AuthenticatedTicketsTicketIdRoute
  AuthenticatedUsersUserIdRoute: typeof AuthenticatedUsersUserIdRoute
  AuthenticatedWalletGoldBuyRequestsRoute: typeof AuthenticatedWalletGoldBuyRequestsRoute
  AuthenticatedWalletGoldCashTransactionsRoute: typeof AuthenticatedWalletGoldCashTransactionsRoute
  AuthenticatedWalletGoldCreaditTransactionsRoute: typeof AuthenticatedWalletGoldCreaditTransactionsRoute
  AuthenticatedWalletGoldSellRequestsRoute: typeof AuthenticatedWalletGoldSellRequestsRoute
  AuthenticatedAccountingOrdersIndexRoute: typeof AuthenticatedAccountingOrdersIndexRoute
  AuthenticatedAcquiredUserBannerIndexRoute: typeof AuthenticatedAcquiredUserBannerIndexRoute
  AuthenticatedAcquiredUsersIndexRoute: typeof AuthenticatedAcquiredUsersIndexRoute
  AuthenticatedActivityLogIndexRoute: typeof AuthenticatedActivityLogIndexRoute
  AuthenticatedActivityTypesIndexRoute: typeof AuthenticatedActivityTypesIndexRoute
  AuthenticatedAppsIndexRoute: typeof AuthenticatedAppsIndexRoute
  AuthenticatedAttributesIndexRoute: typeof AuthenticatedAttributesIndexRoute
  AuthenticatedBrandPagesIndexRoute: typeof AuthenticatedBrandPagesIndexRoute
  AuthenticatedBrandsIndexRoute: typeof AuthenticatedBrandsIndexRoute
  AuthenticatedCategoriesIndexRoute: typeof AuthenticatedCategoriesIndexRoute
  AuthenticatedChatsIndexRoute: typeof AuthenticatedChatsIndexRoute
  AuthenticatedColorsIndexRoute: typeof AuthenticatedColorsIndexRoute
  AuthenticatedCompanyBankAccountsIndexRoute: typeof AuthenticatedCompanyBankAccountsIndexRoute
  AuthenticatedDeliveryOrdersIndexRoute: typeof AuthenticatedDeliveryOrdersIndexRoute
  AuthenticatedDepositAllocationsIndexRoute: typeof AuthenticatedDepositAllocationsIndexRoute
  AuthenticatedDepositsCompanyViewIndexRoute: typeof AuthenticatedDepositsCompanyViewIndexRoute
  AuthenticatedDepositsCompanyIndexRoute: typeof AuthenticatedDepositsCompanyIndexRoute
  AuthenticatedDepositsPersonalViewIndexRoute: typeof AuthenticatedDepositsPersonalViewIndexRoute
  AuthenticatedDepositsPersonalIndexRoute: typeof AuthenticatedDepositsPersonalIndexRoute
  AuthenticatedGoldPricingIndexRoute: typeof AuthenticatedGoldPricingIndexRoute
  AuthenticatedHelpCenterIndexRoute: typeof AuthenticatedHelpCenterIndexRoute
  AuthenticatedHomepageSectionsIndexRoute: typeof AuthenticatedHomepageSectionsIndexRoute
  AuthenticatedLoginBannerIndexRoute: typeof AuthenticatedLoginBannerIndexRoute
  AuthenticatedMoltenGoldSettingsIndexRoute: typeof AuthenticatedMoltenGoldSettingsIndexRoute
  AuthenticatedOrdersIndexRoute: typeof AuthenticatedOrdersIndexRoute
  AuthenticatedPayoutsViewIndexRoute: typeof AuthenticatedPayoutsViewIndexRoute
  AuthenticatedPayoutsIndexRoute: typeof AuthenticatedPayoutsIndexRoute
  AuthenticatedPersonalBankAccountsIndexRoute: typeof AuthenticatedPersonalBankAccountsIndexRoute
  AuthenticatedPlpsIndexRoute: typeof AuthenticatedPlpsIndexRoute
  AuthenticatedPopularManufacturersIndexRoute: typeof AuthenticatedPopularManufacturersIndexRoute
  AuthenticatedProductsIndexRoute: typeof AuthenticatedProductsIndexRoute
  AuthenticatedPromoBannersIndexRoute: typeof AuthenticatedPromoBannersIndexRoute
  AuthenticatedRialAdjustmentsIndexRoute: typeof AuthenticatedRialAdjustmentsIndexRoute
  AuthenticatedRolesIndexRoute: typeof AuthenticatedRolesIndexRoute
  AuthenticatedSizesIndexRoute: typeof AuthenticatedSizesIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedTermsIndexRoute: typeof AuthenticatedTermsIndexRoute
  AuthenticatedTicketCategoriesIndexRoute: typeof AuthenticatedTicketCategoriesIndexRoute
  AuthenticatedTicketsIndexRoute: typeof AuthenticatedTicketsIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedDeliveryOrdersPrintOrderIdRoute: typeof AuthenticatedDeliveryOrdersPrintOrderIdRoute
  AuthenticatedOrdersFactorOrderIdRoute: typeof AuthenticatedOrdersFactorOrderIdRoute
  AuthenticatedOrdersPrintOrderIdRoute: typeof AuthenticatedOrdersPrintOrderIdRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminSettingsRouteRoute:
    AuthenticatedAdminSettingsRouteRouteWithChildren,
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedAnnouncementsRoute: AuthenticatedAnnouncementsRoute,
  AuthenticatedTutorialsRoute: AuthenticatedTutorialsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAccountingOrdersOrderIdRoute:
    AuthenticatedAccountingOrdersOrderIdRoute,
  AuthenticatedDeliveryOrdersOrderIdRoute:
    AuthenticatedDeliveryOrdersOrderIdRoute,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
  AuthenticatedOrdersOrderIdRoute: AuthenticatedOrdersOrderIdRoute,
  AuthenticatedProductsProductIdRoute: AuthenticatedProductsProductIdRoute,
  AuthenticatedReportsBalanceRoute: AuthenticatedReportsBalanceRoute,
  AuthenticatedReportsLoginsRoute: AuthenticatedReportsLoginsRoute,
  AuthenticatedReportsOtpsRoute: AuthenticatedReportsOtpsRoute,
  AuthenticatedReportsStockRoute: AuthenticatedReportsStockRoute,
  AuthenticatedStaffUserIdRoute: AuthenticatedStaffUserIdRoute,
  AuthenticatedTicketsTicketIdRoute: AuthenticatedTicketsTicketIdRoute,
  AuthenticatedUsersUserIdRoute: AuthenticatedUsersUserIdRoute,
  AuthenticatedWalletGoldBuyRequestsRoute:
    AuthenticatedWalletGoldBuyRequestsRoute,
  AuthenticatedWalletGoldCashTransactionsRoute:
    AuthenticatedWalletGoldCashTransactionsRoute,
  AuthenticatedWalletGoldCreaditTransactionsRoute:
    AuthenticatedWalletGoldCreaditTransactionsRoute,
  AuthenticatedWalletGoldSellRequestsRoute:
    AuthenticatedWalletGoldSellRequestsRoute,
  AuthenticatedAccountingOrdersIndexRoute:
    AuthenticatedAccountingOrdersIndexRoute,
  AuthenticatedAcquiredUserBannerIndexRoute:
    AuthenticatedAcquiredUserBannerIndexRoute,
  AuthenticatedAcquiredUsersIndexRoute: AuthenticatedAcquiredUsersIndexRoute,
  AuthenticatedActivityLogIndexRoute: AuthenticatedActivityLogIndexRoute,
  AuthenticatedActivityTypesIndexRoute: AuthenticatedActivityTypesIndexRoute,
  AuthenticatedAppsIndexRoute: AuthenticatedAppsIndexRoute,
  AuthenticatedAttributesIndexRoute: AuthenticatedAttributesIndexRoute,
  AuthenticatedBrandPagesIndexRoute: AuthenticatedBrandPagesIndexRoute,
  AuthenticatedBrandsIndexRoute: AuthenticatedBrandsIndexRoute,
  AuthenticatedCategoriesIndexRoute: AuthenticatedCategoriesIndexRoute,
  AuthenticatedChatsIndexRoute: AuthenticatedChatsIndexRoute,
  AuthenticatedColorsIndexRoute: AuthenticatedColorsIndexRoute,
  AuthenticatedCompanyBankAccountsIndexRoute:
    AuthenticatedCompanyBankAccountsIndexRoute,
  AuthenticatedDeliveryOrdersIndexRoute: AuthenticatedDeliveryOrdersIndexRoute,
  AuthenticatedDepositAllocationsIndexRoute:
    AuthenticatedDepositAllocationsIndexRoute,
  AuthenticatedDepositsCompanyViewIndexRoute:
    AuthenticatedDepositsCompanyViewIndexRoute,
  AuthenticatedDepositsCompanyIndexRoute:
    AuthenticatedDepositsCompanyIndexRoute,
  AuthenticatedDepositsPersonalViewIndexRoute:
    AuthenticatedDepositsPersonalViewIndexRoute,
  AuthenticatedDepositsPersonalIndexRoute:
    AuthenticatedDepositsPersonalIndexRoute,
  AuthenticatedGoldPricingIndexRoute: AuthenticatedGoldPricingIndexRoute,
  AuthenticatedHelpCenterIndexRoute: AuthenticatedHelpCenterIndexRoute,
  AuthenticatedHomepageSectionsIndexRoute:
    AuthenticatedHomepageSectionsIndexRoute,
  AuthenticatedLoginBannerIndexRoute: AuthenticatedLoginBannerIndexRoute,
  AuthenticatedMoltenGoldSettingsIndexRoute:
    AuthenticatedMoltenGoldSettingsIndexRoute,
  AuthenticatedOrdersIndexRoute: AuthenticatedOrdersIndexRoute,
  AuthenticatedPayoutsViewIndexRoute: AuthenticatedPayoutsViewIndexRoute,
  AuthenticatedPayoutsIndexRoute: AuthenticatedPayoutsIndexRoute,
  AuthenticatedPersonalBankAccountsIndexRoute:
    AuthenticatedPersonalBankAccountsIndexRoute,
  AuthenticatedPlpsIndexRoute: AuthenticatedPlpsIndexRoute,
  AuthenticatedPopularManufacturersIndexRoute:
    AuthenticatedPopularManufacturersIndexRoute,
  AuthenticatedProductsIndexRoute: AuthenticatedProductsIndexRoute,
  AuthenticatedPromoBannersIndexRoute: AuthenticatedPromoBannersIndexRoute,
  AuthenticatedRialAdjustmentsIndexRoute:
    AuthenticatedRialAdjustmentsIndexRoute,
  AuthenticatedRolesIndexRoute: AuthenticatedRolesIndexRoute,
  AuthenticatedSizesIndexRoute: AuthenticatedSizesIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedTermsIndexRoute: AuthenticatedTermsIndexRoute,
  AuthenticatedTicketCategoriesIndexRoute:
    AuthenticatedTicketCategoriesIndexRoute,
  AuthenticatedTicketsIndexRoute: AuthenticatedTicketsIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedDeliveryOrdersPrintOrderIdRoute:
    AuthenticatedDeliveryOrdersPrintOrderIdRoute,
  AuthenticatedOrdersFactorOrderIdRoute: AuthenticatedOrdersFactorOrderIdRoute,
  AuthenticatedOrdersPrintOrderIdRoute: AuthenticatedOrdersPrintOrderIdRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  authSignInRoute: authSignInRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
